import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';


@Injectable()
export class StorageService {

    private _storage: Storage | null = null;

    constructor() {
        this.init();
    }

    async init() {
        const storageConfig = {
            name: '_biometricstorage',
            storeName: '_biometrickv',
            dbKey: '_biometrickey'
        }
        const myStorage = new Storage(storageConfig);
        this._storage = await myStorage.create();
    }

    public set(key: string, value: any) {
        return this._storage?.set(key, value);
    }

    public get(key: string) {
        return this._storage?.get(key);
    }

    public remove(key: string) {
        return this._storage.remove(key);
    }

    public clear() {
        return this._storage.clear();
    }

    public keys() {
        return this._storage.keys();
    }
}